import styled from 'styled-components'
import {
  useAddUnityFormModalContext,
  useErrorHandlerContext,
  useOpeningElementsControllerContext,
  usePropertyDetailContext,
  useUserLanguage,
} from '@/customHooks'
import { bedSizeMapper, capitalizeFirstLetter } from '@/helpers'
import { UnityStatusOption, useDeleteUnityFromPropertyMutation } from '@/graphql/generated'
import { ButtonWithDropDownMenu } from '../molecules'
import { Col, Row } from 'react-grid-system'
import { Button } from '../atoms'
import textsData from '@/textData/PropertyDetailTexts.json';
import { UnityStatusOptionPill } from '../atoms/UnityStatusOptionPill'

const StyledGridTable = styled.div`
  padding-top: ${({ theme }) => theme.spacing.lg} ;
  padding-bottom: ${({ theme }) => theme.spacing.lg} ;
  border-radius: 12px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 64px;
  row-gap: 0;
`;

const StyledGridHeader = styled.div`
  display: contents;
  & > div {
    font-weight: bold;
    text-align: left;
    padding: 15px;
    border-top: 1px solid grey;
    border-bottom: 1px solid gray;
  }
`;

const StyledGridRow = styled.div`
  display: contents;
  
  & > div {
    padding: 15px;
    font-size: 14px;
    padding-top: 1rem;
    padding-bottom: 1rem;
    align-self: stretch;
    place-content: center;
    border-bottom: solid 1px lightgray;
    background-color: ${({ theme }) => theme.colors.light};
  }

  &:nth-of-type(odd) > div {
    background-color: ${({ theme }) => theme.colors.background2};
  }
`;

export const PropertyDetailUnitsList = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es.unityDetail : textsData.en.unityDetail

  const [deleteUnity] = useDeleteUnityFromPropertyMutation()

  const { setProperty } = usePropertyDetailContext()

  const { openModal } = useAddUnityFormModalContext()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const { property } = usePropertyDetailContext()

  const unities = property?.unities ?? []

  const { open } = useErrorHandlerContext()

  console.log(unities)
  const onDeleteHandle = (unityId: string) => {
    //TODO: Colocar un modal de confirmación previo a eliminar el registro. 250402 
    const selectedUnity = property?.unities.find((unity) => unity.id === unityId)

    if (selectedUnity?.currentStatusOption === UnityStatusOption.Occupied) {
      confirmDialogModalOpen({
        title: 'Advertencia',
        description: 'Para poder eliminar una Unidad debe estar en estado "Vacante"',
      })
    }
    else {
      deleteUnity({
        variables: {
          propertyId: property?.id ?? '',
          unityId,
        }
      })
        .then((response) => {
          setProperty(undefined)  // Change context for forcing a refetch from father component
          confirmDialogModalOpen({
            title: texts.deleteConfirmation.title,
            description: `${response.data?.deleteUnityFromProperty.name} ${texts.deleteConfirmation.description}`,
          })
        })
        .catch(open)
    }
  }

  return (
    <>
      <Row justify="end" align="center">
        <Col xs='content' style={{ marginTop: '1rem' }}>
          <Button
            onClick={() => openModal()}
          >
            {texts.button}
          </Button>
        </Col>
      </Row>
      {
        unities?.length === 0
        ? (
          <Row>
            <Col>
              <p><b>{texts.noData}</b></p>
            </Col>
          </Row>
        )
        : (
          <Row>
            <Col>
              <StyledGridTable>
                {/* Encabezado */}
                <StyledGridHeader>
                  <div>ID</div>
                  <div>{texts.tableHeader.name}</div>
                  <div>{texts.tableHeader.bedSize}</div>
                  <div>{texts.tableHeader.bathroom}</div>
                  <div>{texts.tableHeader.airConditioner}</div>
                  <div>{texts.tableHeader.fan}</div>
                  <div>{texts.tableHeader.currentStatus}</div>
                  <div></div>
                </StyledGridHeader>

                {/* Filas dinámicas */}
                {unities?.map((data) => (
                  <StyledGridRow key={data.id}>
                    <div>{data.id}</div>
                    <div>{capitalizeFirstLetter(data.name)}</div>
                    <div>{bedSizeMapper(data.bedSizeOption, userLanguage)}</div>
                    <div><input type='checkbox' readOnly checked={data.privateBathroom} /></div>
                    <div><input type='checkbox' readOnly checked={data.airConditioner} /></div>
                    <div><input type='checkbox' readOnly checked={data.fan} /></div>
                    <div>
                      <UnityStatusOptionPill option={data.currentStatusOption} />
                    </div>
                    <div>
                      <ButtonWithDropDownMenu
                        options={[
                          { item: texts.dropdownMenu.edit, action: () => openModal(data) },
                          { item: texts.dropdownMenu.delete, action: () => onDeleteHandle(data.id) },
                        ]}
                        position='left'
                      />
                    </div>
                  </StyledGridRow>
                )) ?? null}
              </StyledGridTable>
            </Col>
          </Row>
        )
      }
    </>
  )
};
